import { Notification, toast } from "components/ui";
import { PLACEMENT } from "components/ui/utils/constant";

export const useToastHandler = () => {
  const triggerToast = (
    title = "Failed",
    message = "something went wrong",
    type = "danger"
  ) => {
    toast.push(
      <Notification duration={5000} title={title} type={type} className="break-all">
        {message}
      </Notification>,
      {
        placement: PLACEMENT.BOTTOM_END,
      }
    );
  };

  const onErrorHandler = (title, error, Error) => {
    if (error?.status === false) {
      triggerToast(title, error?.message);
      // setter(error?.message);
      return;
    }

    if (error?.detail) {
      triggerToast(title, error?.detail);
      return
    }

    if (error?.message) {
      triggerToast(title, error?.message);
      return
    }

    if (error?.data?.message) {
      triggerToast(title, error?.data?.message);
      return
    }

    if (typeof error === "string") {
      // setter(error);
      triggerToast(title, error);
      return;
    }

    triggerToast(title, "Unknown error occurred");
  };

  const onSuccessHandler = (title, message) => {
    triggerToast(title, message, "success");
  };

  return [onSuccessHandler, onErrorHandler];
};
